<template><div><h1 id="_6-mailingauswertung" tabindex="-1"><a class="header-anchor" href="#_6-mailingauswertung"><span>6. Mailingauswertung</span></a></h1>
<p>Die <em>Ereignisauswertung</em> ist eine Methode, die eine schnelle und aktuelle Analyse von Mailing-Aktionen in Excel Pivot-Tabellen erlaubt.</p>
<h1 id="prozedur-mailingauswertung" tabindex="-1"><a class="header-anchor" href="#prozedur-mailingauswertung"><span>Prozedur Mailingauswertung</span></a></h1>
<ol>
<li>
<p>Vorbereitungen: Die folgenden Schritte müssen nur ein Mal durchgeführt werden.</p>
<ol>
<li>
<p><RouteLink to="/referenz/refs/ft.refdata.eadimdef.html" title="Dimensionen definieren">Dimensionen definieren</RouteLink> Hier wird die Nummer des Ereignisses, das analysiert werden soll, eingegeben.</p>
<p>Für die Klassifikation der Adressen in der Auswertung ist typischerweise nicht das aktuelle Datum wichtig, sondern der Stand des Systems zur Zeit des Aussands. Welchen Systemstand die Ereignisauswertung für die Klassifikation der Adressen verwendet, kann im Feld Stichtag festgelegt werden. Dieser dient lediglich für die datenabhängigen Dimensionen wie Alter, Personenstatus, etc. um den Stand des Wertes an diesem Datum zu wiedergeben.</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Für die Auswertung werden alle Initialereignisse verwendet (unabhängig) vom Stichtag. Response und Refusé-Ereignisse hingegen nur auf existierende Initialereignisse. Durch diese Definition kann die Auswertung gegenüber den Werten im Ereigniskopf variieren, da es auch Response und Refusé-Ereignisse ohne Initialereignisse vorkommen.</p>
</div>
</li>
<li>
<p>Definition der zugehörigen <RouteLink to="/referenz/refs/ft.refdata.eadimdefpos.html" title="Dimensionen definieren, Positionen">Positionen</RouteLink>. Für jedes Kriterium, das bei den regelmässigen Auswertungen verwendet werden sollte, muss eine entsprechende Dimension erfasst werden. Die Liste der möglichen Dimensionen ist in <RouteLink to="/referenz/refs/ft.refdata.tbldim.html" title="Dimension">Dimension</RouteLink> zu finden.</p>
<p>Für bestimmte Dimensionen müssen an dieser Stelle auch Parameter eingegeben werden (siehe <RouteLink to="/referenz/refs/ft.refdata.tbldim.html" title="Dimension">Dimension</RouteLink> für Details). Gruppierungen hingegen werden noch nicht vorgegeben.</p>
</li>
<li>
<p>Berechnen und Vergeben der Dimensionen. Das System berechnet die Klassifizierungen in den Auswertedimensionen für jede Adresse mit einem Initialereignis (wie sie zum Auswertezeitpunkt war).</p>
<div class="hint-container warning">
<p class="hint-container-title">Wichtig</p>
<p>Dieser Job hat eine sehr lange Laufzeit (für grosse Aktionen).</p>
</div>
</li>
</ol>
</li>
<li>
<p>Einrichten einer oder mehrerer <RouteLink to="/referenz/refs/ft.refdata.eamaildef.html" title="Mailingauswertung">Mailingauswertungen</RouteLink>. Da bei grossen Mailings die Menge der zu exportierenden Daten die Möglichkeiten von Excel sprengen würden, muss ein Extrakt der Daten festgelegt werden. Mehrere Extrakt-Definitionen können im System gespeichert werden, beispielsweise weil unterschiedliche Benutzer unterschiedliche Daten sehen wollen.</p>
</li>
<li>
<p>Extrahieren von aktuellen Daten (<RouteLink to="/referenz/refs/ft.refdata.eamaildef.html#mailingausw.aufbereiten" title="aufbereiten">Job &quot;aufbereiten&quot;</RouteLink>). Regelmässig können aktuelle Response und Refusé-Zahlen in eine Textdatei extrahiert werden. Da die Daten bereits im Voraus berechntet wurden, dauert der Datenextrakt nicht lange.</p>
<div class="hint-container tip">
<p class="hint-container-title">Tipp</p>
<p>Während eine Kampagne läuft, lohnt es sich, den täglichen Extrakt als regelmässigen Hintergrundjob zu definieren.</p>
</div>
</li>
<li>
<p>Import der Daten in Excel.</p>
</li>
<li>
<p>Erstellen einer Pivot-Tabelle zur Analyse der Daten in Excel.</p>
</li>
</ol>
</div></template>


